var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "headline" },
        [
          _c("v-icon", [_vm._v("check")]),
          _vm._v("\n    Aprobar Movilidad .\n    "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Tipo de movilidad:")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.movilidad.tipo_movimiento) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { md12: "" } }, [
                        _c("strong", [_vm._v("Servidor público:")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.movilidad.funcionario.nombre) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { md6: "" } }, [
                        _c("strong", [_vm._v("Item:")]),
                        _vm._v(
                          " " + _vm._s(_vm.movilidad.nro_item) + "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { md6: "" } }, [
                        _c("strong", [_vm._v("Fecha desde :")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.movilidad.fecha_desde) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md6: "" } },
                        [
                          !_vm.cargoEspecial
                            ? _c("v-text-field", {
                                attrs: {
                                  label: "Nro memorándum",
                                  maxlength: "200",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  loading: _vm.loading,
                                  disabled: _vm.loading
                                },
                                model: {
                                  value: _vm.form.nro_memorandum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_memorandum", $$v)
                                  },
                                  expression: "form.nro_memorandum"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md6: "" } },
                        [
                          !_vm.cargoEspecial
                            ? _c("v-text-field", {
                                attrs: {
                                  required: "",
                                  label: "Fecha de memorandum",
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  loading: _vm.loading,
                                  disabled: _vm.loading
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.esFeriadoOFinDeSemana(
                                      _vm.form.fecha_memorandum,
                                      1
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_memorandum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_memorandum", $$v)
                                  },
                                  expression: "form.fecha_memorandum"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md6: "" } },
                        [
                          _vm.movilidad.id_tipo_justificacion == 7 &&
                          !_vm.cargoEspecial
                            ? _c("v-text-field", {
                                attrs: {
                                  label: "Nro resolución",
                                  maxlength: "200",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  loading: _vm.loading,
                                  disabled: _vm.loading
                                },
                                model: {
                                  value: _vm.form.nro_resolucion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_resolucion", $$v)
                                  },
                                  expression: "form.nro_resolucion"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md6: "" } },
                        [
                          _vm.movilidad.id_tipo_justificacion == 7 &&
                          !_vm.cargoEspecial
                            ? _c("v-text-field", {
                                attrs: {
                                  required: "",
                                  label: "Fecha de resolución",
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  loading: _vm.loading,
                                  disabled: _vm.loading
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.esFeriadoOFinDeSemana(
                                      _vm.form.fecha_resolucion,
                                      2
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_resolucion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_resolucion", $$v)
                                  },
                                  expression: "form.fecha_resolucion"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.aprobarRechazar(1)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("check")]), _vm._v(" Aprobar\n      ")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "error", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.aprobarRechazar(0)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("clear")]), _vm._v(" Rechazar\n      ")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9655580", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9655580","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/components/AprobarMovilidadItem.vue
// module id = null
// module chunks = 